import { Button, Box, ButtonGroup, CircularProgress, IconButton, Tooltip, Typography, useTheme, Popover, Drawer, Dialog, Popper, ClickAwayListener, Paper, MenuItem } from "@mui/material"
import DetailsViewer from "../../components/study-material-components/DetailsViewer"
import { useDownloadStatusListStore } from "../../store/downloadstatuslistdialog.store"
import MaterialEdit from "../../components/study-material-components/MaterialEdit"
import FileInput from "../../components/study-material-components/FileInput"
import DataLoadingSpinner from "../../components/common/DataLoadingSpinner"
import GridView from "../../components/study-material-components/GridView"
import ListView from "../../components/study-material-components/ListView"
import BlockMessage from '../../components/common/BlockMessage'
import { useStudyMaterialStore } from '../../store/studymaterial.store'
import CustomSearchBar from "../../components/common/CustomSearchBar"
import ConfirmDialog from "../../components/common/ConfirmDialog"
import { List, Download, Visibility } from "@mui/icons-material"
import { Link, useNavigate, useParams } from "react-router-dom"
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import React, { useEffect, useRef, useState } from "react"
import GridViewIcon from '@mui/icons-material/GridView'
import { toast } from "react-toastify"
import { observer } from "mobx-react"

import { Icons, convertToCDNLink, attachmentThumbnails, getFileSizeFromBytes } from "../../utils/utilities"
import { STUDY_MATERIAL_DESCRIPTION_BLOCK_HEIGHT } from '../../utils/constants'
import BreadcrumbList from "../../components/common/BreadcrumbList"
import DocumentViewer from '../../components/common/DocumentViewer'
import { useSettingsStore } from '../../store/settings.store'
import { useUserStore } from "../../store/user.store"
import api from "../../service/api"

const AddAttachmentsDialog = ( { addMode, setAddMode, getAttachments } ) => {

    const [isUploading, setIsUploading] = useState( false )
    const [attachmentsNames, setAttachmentsNames] = useState( [] )
    const [attachmentsSizes, setAttachmentsSizes] = useState( [] )
    const [selectedAttachments, setSelectedAttachments] = useState( [] )
    const [progress, setProgress] = useState( 0 )

    const [documentUrl, setDocumentUrl] = useState( null )
    const [documentType, setDocumentType] = useState( null )
    const [isDialogOpen, setIsDialogOpen] = useState( false )

    const [filename, setfilename] = useState( null )
    const [anchorEl, setAnchorEl] = useState( null )
    const [formatFiles, setFormatFiles] = useState( [] )

    const SettingsStore = useSettingsStore()
    const StudyMaterialStore = useStudyMaterialStore()

    const { material_id } = useParams()
    const { palette, border } = useTheme()


    const progressHandler = ( event ) => {
        const { loaded, total } = event
        let percent = Math.round( ( loaded * 100 ) / total )
        if ( percent <= 100 ) {
            setProgress( percent )
        }
    }

    const handleOpenPopover = ( event ) => {
        const fileUrlString = SettingsStore.getUseSettings['sample_study_material_format']
        if ( fileUrlString ) {
            const parsedFiles = JSON.parse( fileUrlString )
            setFormatFiles( parsedFiles )
            setAnchorEl( event.currentTarget )
        } else {
            console.error( 'Cannot Retrieve Files' )
        }
    }

    const handleClosePopover = () => {
        setAnchorEl( null )
    }

    const handleCloseDialog = () => {
        setIsDialogOpen( false )
        setDocumentUrl( null )
        setDocumentType( null )
    }

    const handleViewFile = ( file ) => {
        const cdnLink = convertToCDNLink( file.location )
        setDocumentUrl( cdnLink )
        setDocumentType( file.name.split( '.' ).pop() )
        setfilename( file.name )
        setIsDialogOpen( true )
    }

    const handleDownloadFile = ( file ) => {
        const link = document.createElement( 'a' )
        link.href = file.location
        link.download = file.name
        link.click()
        link.remove()
    }

    const uploadAttachments = async () => {
        setIsUploading( true )
        try {
            const formData = new FormData()
            let emptyName = false
            for ( let i = 0; i < attachmentsNames.length; i++ ) {
                const name = attachmentsNames[i]
                if ( name === "" ) {
                    emptyName = true
                }
            }
            if ( !emptyName ) {
                selectedAttachments.forEach( ( attachment, i ) => {
                    let fileName = encodeURIComponent( `${attachment.name}`.replace( /\s/g, '-' ) )
                    formData.append( 'attachments[]', attachment, fileName )
                } )
                formData.append( 'attachmentNames[]', JSON.stringify( attachmentsNames ) )
                formData.append( 'attachmentsSizes[]', JSON.stringify( attachmentsSizes ) )
                await StudyMaterialStore.addAttachments( material_id, formData, progressHandler )
                setIsUploading( false )
                setProgress( 0 )
                setSelectedAttachments( [] )
                setAttachmentsNames( [] )
                setAttachmentsSizes( [] )
                await getAttachments()
            } else {
                toast( "Please provide names for all the attachments" )
            }
        } catch ( e ) {
            console.log( e )
            setIsUploading( false )
            setProgress( 0 )
            await getAttachments()
            if ( e?.response?.data?.data?.unuploaded?.length > 0 ) {
                setSelectedAttachments( [] )
                setAttachmentsNames( [] )
                setAttachmentsSizes( [] )
                let unuploadedFiles = []
                for ( let i = 0; i < e?.response?.data?.data?.unuploaded.length; i++ ) {
                    const file = e?.response?.data?.data?.unuploaded[i]
                    unuploadedFiles.push( file.originalname.replace( /-(\d)+/g, "" ) )
                }
                const toastMsg = <p>Failed to upload these files: <b><i>{unuploadedFiles.join( ", " )}</i></b> due to unsupported format. </p>
                toast( toastMsg )
            } else
                toast( e.response && e.response.data && e.response.data.message )
        } finally {
            setIsUploading( false )
            setProgress( 0 )
        }
    }

    return (
        <Dialog slotProps={{
            paper: {
                sx: { width: "95%", maxWidth: "1024px" }
            }
        }} open={addMode} >

            <Drawer anchor='bottom' sx={{ zIndex: 9000000 }} open={isDialogOpen} slotProps={{
                paper: { sx: { height: "calc(100% - 50px)" } }
            }}>
                <Box bgcolor="background.paper" flexGrow={1} display="flex" overflow="auto" flexDirection="column" borderRadius="20px 20px 0 0">
                    <Box borderBottom={1} alignItems="center" display="flex" justifyContent="space-between" gap="20px" padding="10px 20px">
                        <Typography variant='h6'>{filename}</Typography>
                        <Box display="flex" gap="10px" alignItems="center">
                            <IconButton onClick={handleCloseDialog}>
                                {Icons.default.CloseIcon}
                            </IconButton>
                        </Box>
                    </Box>
                    <Box display="flex" flexDirection="column" overflow="auto" flexGrow={1} padding="20px" height="300px">
                        <DocumentViewer type={documentType} loadingText="Loading material..." file={documentUrl} />
                    </Box>
                </Box>
            </Drawer>

            <Popover open={Boolean( anchorEl )} anchorEl={anchorEl} onClose={handleClosePopover} anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }} transformOrigin={{ vertical: 'top', horizontal: 'left', }}>
                <Box sx={{ p: 2, maxWidth: 400 }}>
                    {formatFiles.slice( 2 ).map( ( file, index ) => (
                        <Box key={index} gap="10px" padding='5px' sx={{ display: 'flex', alignItems: 'center' }}>
                            <img style={{ objectFit: "cover" }} width="45px" src={attachmentThumbnails[file.name?.split( "." ).pop()] ? attachmentThumbnails[file.name?.split( "." ).pop()] : attachmentThumbnails["default"]} alt={file.type} />
                            <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="subtitle2" fontSize="12px">{file.name}</Typography>
                                <Typography variant="subtitle2" fontSize="10px" color="text.secondary">
                                    {getFileSizeFromBytes( file.size )}
                                </Typography>
                            </Box>
                            <IconButton onClick={() => handleViewFile( file )}>
                                <Visibility />
                            </IconButton>
                            <IconButton onClick={() => handleDownloadFile( file )}>
                                <Download />
                            </IconButton>
                        </Box>
                    ) )}
                </Box>
            </Popover>

            <Box padding="10px 20px" display="flex" alignItems="center" borderBottom={border[1]} justifyContent="space-between" gap="20px">
                <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Upload New Materials</Typography>
                <IconButton onClick={() => setAddMode( false )}>
                    {Icons.default.CloseIcon}
                </IconButton>
            </Box>
            <Box padding="10px 20px">
                <Box display="flex" sx={{ borderRadius: "5px", background: palette.errorMessage.main, padding: "10px", marginBottom: "20px", alignItems: "flex-start" }}>
                    <Box sx={{ marginRight: "5px", marginTop: "5px", color: "white", fontSize: "20px" }} >
                        {Icons.default.Info}
                    </Box>
                    <Box padding="5px 0" display="flex" gap="10px" flexDirection="column">
                        <Typography variant="body2" color="white" sx={{ fontWeight: "bold", textTransform: "capitalize" }}>
                            Note: {SettingsStore.getUseSettings['sample_study_material_format_note'] || "The institute has recommended a specific format for creating and uploading Study material, we recommend to do the same"}
                        </Typography>
                        {SettingsStore.getUseSettings['sample_study_material_format'] && Array.isArray( JSON.parse( SettingsStore.getUseSettings['sample_study_material_format'] ) ) && JSON.parse( SettingsStore.getUseSettings['sample_study_material_format'] ).length > 0 && (
                            <Box display="flex" gap="5px" alignItems="center" flexWrap="wrap">
                                {JSON.parse( SettingsStore.getUseSettings['sample_study_material_format'] ).slice( 0, 2 ).map( ( file, index ) => (
                                    <Box borderRadius="20px" bgcolor={"white"} key={index} gap="10px" padding='5px' sx={{ display: 'flex', alignItems: 'center' }}>
                                        <img style={{ objectFit: "cover" }} width="35px" src={attachmentThumbnails[file.name?.split( "." ).pop()] ? attachmentThumbnails[file.name?.split( "." ).pop()] : attachmentThumbnails["default"]} alt={file.type} />
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Typography variant="subtitle2" color="black" component="p" fontSize="12px">{file.name}</Typography>
                                            <Typography variant="subtitle2" display="block" marginTop="-5px" color="black" fontSize="10px">
                                                {getFileSizeFromBytes( file.size )}
                                            </Typography>
                                        </Box>
                                        <IconButton color="black" sx={{ color: "black" }} size='small' onClick={() => handleViewFile( file )}>
                                            <Visibility sx={{ fontSize: "18px" }} />
                                        </IconButton>
                                        <IconButton color="black" sx={{ color: "black" }} size='small' onClick={() => handleDownloadFile( file )}>
                                            <Download sx={{ fontSize: "18px" }} />
                                        </IconButton>
                                    </Box>
                                ) )}
                                {JSON.parse( SettingsStore.getUseSettings['sample_study_material_format'] ).length > 2 && <Button endIcon={Icons.default.KeyboardArrowDownIcon} sx={{ width: "fit-content", color: "white", fontWeight: "400", textTransform: "capitalize" }}
                                    onClick={handleOpenPopover}>
                                    View more
                                </Button>}
                            </Box>
                        )}
                    </Box>
                </Box>
                <FileInput attachmentsSizes={attachmentsSizes} setAttachmentsSizes={setAttachmentsSizes} size={60} progress={progress} isUploading={isUploading} setFieldValue={( name, value ) => { }} setAttachmentsNames={setAttachmentsNames} attachmentsNames={attachmentsNames} selectedAttachments={selectedAttachments} setSelectedAttachments={setSelectedAttachments} />
                <Box display="flex" justifyContent="flex-end" alignItems="center" flexWrap="wrap" gap="10px">
                    {addMode > 0 && <Button onClick={() => setAddMode( false )} disabled={isUploading} startIcon={Icons.default.CloseIcon} color='error' sx={{ textTransform: "capitalize", marginY: "20px" }} variant="outlined">Cancel</Button>}
                    <Button onClick={uploadAttachments} disabled={isUploading || selectedAttachments.length === 0} startIcon={isUploading ? <CircularProgress size={10} /> : <CloudUploadIcon />} sx={{ textTransform: "capitalize", marginY: "20px" }} variant="contained" disableElevation>{isUploading ? "Uploading materials..." : "Upload Materials"}</Button>
                </Box>
            </Box>
        </Dialog>
    )
}

const Material = observer( ( { fromSubject = false } ) => {

    const [viewType, setViewType] = useState( localStorage.getItem( "studyMaterialView" ) || "grid" )
    const [attachmentsSelectedForDetails, setAttachmentsSelectedForDetails] = useState( null )
    const [showDetails, setShowDetails] = useState( false )
    const [addMode, setAddMode] = useState( false )
    const [data, setData] = useState( null )
    const [attachments, setAttachments] = useState( null )
    const [isLoading, setIsLoading] = useState( true )
    const [editMode, setEditMode] = useState( false )
    const [deleting, setDeleting] = useState( false )
    const [filteredAttachments, setFilteredAttachments] = useState( null )
    const [searchParameter, setSearchParameter] = useState( '' )
    const [isUpdating, setIsUpdating] = useState( false )
    const [isDownloading, setIsDownloading] = useState( false )
    const [materialDeleteDialogState, setMaterialDeleteDialogState] = useState( false )
    const [actionsAnchorEl, setActionsAnchorEl] = useState( null )

    const { material_id, subject_id } = useParams()

    const UserStore = useUserStore()
    const StudyMaterialStore = useStudyMaterialStore()
    const DownloadStatusListStore = useDownloadStatusListStore()

    const [descriptionBlockExpandBtnLabel, setDescriptionBlockExpandBtnLabel] = useState( '' )

    const navigate = useNavigate()


    const { palette, border, layout } = useTheme()

    const descriptionRef = useRef()


    const searchAttachments = ( e ) => {
        const filter = attachments.filter( a => {
            return a.study_material_attachment_title?.toLowerCase()?.includes( e.target.value?.toLowerCase() )
        } )
        setSearchParameter( e.target.value )
        setFilteredAttachments( filter )
    }

    const getAttachments = async () => {
        try {
            await StudyMaterialStore.fetchAttachments( material_id )
            setAttachments( StudyMaterialStore.getAttachments )
            const filtered = StudyMaterialStore.getAttachments.filter( attachment => attachment.study_material_attachment_name.includes( searchParameter ) )
            setFilteredAttachments( filtered )
        } catch ( e ) {
            console.log( e )
            toast.error( e.response && e.response.data && e.response.data.message )
        }
    }

    const downloadStudyMaterial = async () => {
        setIsDownloading( true )
        toast( `Downloading ${data.study_material_name}...`, { position: "bottom-left" } )
        try {
            await DownloadStatusListStore.downloadMaterial( material_id, data )
        } catch ( e ) {
            console.log( e )
            toast.error( e.response && e.response.data && e.response.data.message )
        } finally {
            setIsDownloading( false )
        }
    }

    const deleteAttachment = async ( id ) => {
        try {
            await StudyMaterialStore.deleteAttachment( id )
            getAttachments()
        } catch ( e ) {
            console.log( e )
            toast.error( e.response && e.response.data && e.response.data.message )
        }
    }

    const deleteMaterial = async () => {
        try {
            setDeleting( true )
            await StudyMaterialStore.deleteMaterial( material_id )
            await StudyMaterialStore.fetchMaterials()
            navigate( '/faculty/material' )
        } catch ( e ) {
            console.log( e )
            toast.error( e.response && e.response.data && e.response.data.message )
        } finally {
            setDeleting( false )
        }
    }

    const renameAttachment = async ( id, value ) => {
        try {
            const res = await api.renameAttachment( material_id, id, { new_title: value } )
            getAttachments()
            toast( res.data.data )
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data )
        }
    }

    const removefilter = () => {
        setFilteredAttachments( [...attachments] )
        setSearchParameter( "" )
    }

    const update = async ( values ) => {
        setIsUpdating( true )
        try {
            setData( await StudyMaterialStore.updateMaterial( material_id, { name: values.materialName, description: values.materialDescription, tags: values.tags } ) )
            setEditMode( false )
        } catch ( e ) {
            console.log( e )
            toast.error( e.response && e.response.data && e.response.data.message )
        } finally {
            setIsUpdating( false )
        }
    }

    const navigateToMaterials = () => {
        console.log( subject_id )
        if ( !fromSubject )
            navigate( UserStore.getUser['user_role'] === "STUDENT" ? `/student/material?mode=manage&institute=${localStorage.getItem( 'materialsSearchInstitute' ) || "0"}&searchText=${localStorage.getItem( 'materialsSearchText' ) || ""}` : '/faculty/material' )
        else
            navigate( UserStore.getUser['user_role'] === "STUDENT" ? `/student/subject/${subject_id}/materials` : `/faculty/subject/${subject_id}/materials` )
    }

    useEffect( () => {
        const getData = async () => {
            try {
                await StudyMaterialStore.fetchMaterial( material_id )
                setData( StudyMaterialStore.getMaterial['studyMaterial'] )
                setAttachments( StudyMaterialStore.getMaterial['attachments'] )
                setFilteredAttachments( StudyMaterialStore.getMaterial['attachments'] )
            } catch ( e ) {
                console.log( e )
            } finally {
                setIsLoading( false )
            }
        }
        getData()
    }, [material_id, navigate, UserStore, StudyMaterialStore] )

    useEffect( () => {
        const descriptionBlock = descriptionRef.current
        if ( !descriptionBlock )
            return setDescriptionBlockExpandBtnLabel( false )
        console.log( descriptionBlock.scrollHeight )

        if ( descriptionBlock.scrollHeight > STUDY_MATERIAL_DESCRIPTION_BLOCK_HEIGHT ) {
            setDescriptionBlockExpandBtnLabel( "Show more" )
        } else {
            setDescriptionBlockExpandBtnLabel( "" )
        }
    }, [data] )


    return (
        // <Layout navHeadText="Study Material">
        // </Layout>
        <Box flexGrow={1} display="flex" flexDirection="column" overflow="auto" padding={layout.pagePadding}>

            {/* Helper Components and Dialogs */}
            <ConfirmDialog status={materialDeleteDialogState} waiting={deleting} confirmAction={deleteMaterial} cancelAction={() => setMaterialDeleteDialogState( false )} actionName="Delete" message={<p variant="body2">Do you really want to delete <strong><em>{data?.study_material_name}</em></strong>. All the attachments will be deleted!</p>} />
            {!fromSubject && <BreadcrumbList items={[
                { link: UserStore.getUser['user_role'] === "STUDENT" ? `/student/material?mode=manage&institute=${localStorage.getItem( 'materialsSearchInstitute' ) || "0"}&searchText=${localStorage.getItem( 'materialsSearchText' ) || ""}` : '/faculty/material', label: "Study Materials" },
                data ? data?.study_material_name : "",
                editMode ? 'Edit' : ""
            ]} />}

            <AddAttachmentsDialog addMode={addMode} setAddMode={setAddMode} getAttachments={getAttachments} />

            {/* {fromSubject && <Button sx={{ textTransform: 'capitalize', marginTop: "-10px", marginBottom: "10px" }} startIcon={Icons.default.ArrowBack} onClick={() => navigate( `${UserStore.getUser['user_role'] === "STUDENT" ? `/student/subject/${SubjectStore.getSubject.subject_id}/materials` : `/faculty/subject/${SubjectStore.getSubject.subject_id}/materials`}` )} >Back to materials</Button>} */}
            {!isLoading && data.study_material_id && !editMode &&
                <Box display="flex" flexDirection="column" sx={{ flexGrow: 1 }}>
                    {attachmentsSelectedForDetails && <DetailsViewer attachment={attachmentsSelectedForDetails} setShowDetails={setShowDetails} open={showDetails} />}

                    <Box display="flex" flexDirection="column" gap="10px">
                        <Box>
                            <Typography marginTop="3px" variant="h6" fontSize="16px" color="primaryDark">{data.study_material_name}</Typography>
                            <Typography ref={descriptionRef} width="100%" maxHeight={!descriptionBlockExpandBtnLabel ? `${STUDY_MATERIAL_DESCRIPTION_BLOCK_HEIGHT}px` : descriptionBlockExpandBtnLabel === "Show less" ? "none" : `${STUDY_MATERIAL_DESCRIPTION_BLOCK_HEIGHT}px`} fontSize="12px" minWidth={0} variant="body2">{data.study_material_desc}</Typography>
                            {descriptionBlockExpandBtnLabel && <Typography onClick={() => setDescriptionBlockExpandBtnLabel( prev => prev === "Show more" ? "Show less" : prev === "Show less" ? "Show more" : "" )} sx={{ cursor: "pointer" }} fontSize="12px" color="secondary"><em><u><strong>{descriptionBlockExpandBtnLabel}</strong></u></em></Typography>}
                        </Box>
                        <Box display="flex" justifyContent="space-between" gap="20px" flexWrap="wrap" alignItems="center">
                            <Box flexGrow={1} flexWrap="wrap" alignItems="center" display="flex" gap="10px" >
                                {data.study_material_tags && data.study_material_tags.split( "," ).length > 0 && data.study_material_tags.split( "," ).map( ( tag, index ) => {
                                    return UserStore.getUser.user_role !== "STUDENT" ? (
                                        <Typography borderRadius="5px" padding="2px 10px" fontSize="12px" variant="subtitle2" sx={{ border: border[1], cursor: "pointer" }} key={index}>{tag}</Typography>
                                    ) : (
                                        <Link to={`/student/material?searchText=${tag?.replace( "#", '' )}`} className='default-link' key={index}>
                                            <Typography fontSize="12px" borderRadius="5px" padding="2px 10px" variant="subtitle2" title={`Search materials with tag '${tag}'`} sx={{ border: border[1], cursor: "pointer", ":hover": { borderStyle: "dashed", borderColor: palette.secondary.main } }}>{tag}</Typography>
                                        </Link>
                                    )
                                } )}
                            </Box>
                        </Box>
                    </Box>
                    <Box marginTop="20px" display="flex" justifyContent={{ md: "flex-start", xs: "space-between" }} flexWrap="wrap" gap="10px" >
                        <CustomSearchBar onChange={searchAttachments} value={searchParameter} placeholder="Search attachments..." style={{ flexGrow: 1, width: "200px" }} />
                        <Box display="flex" justifyContent={{ md: "flex-start", xs: "space-between" }} flexWrap="wrap" gap="10px">
                            {!addMode && +data.creator_user_id === +UserStore.getUser['user_id'] && <Tooltip title={addMode ? "Cancel" : "Add more attachments"}>
                                <Button sx={{ flexGrow: 1 }} startIcon={addMode ? Icons.default.CloseIcon : Icons.default.AddIcon} variant='contained' disableElevation color={addMode ? "error" : 'primary'} size="small" onClick={() => setAddMode( !addMode )} >
                                    {addMode ? "Cancel" : "Add Materials"}
                                </Button>
                            </Tooltip>}
                            {+data.creator_user_id === +UserStore.getUser['user_id'] && UserStore.getUser.user_role !== "STUDENT" && <Tooltip disableInteractive title="Edit material details" placement="top">
                                <Button startIcon={Icons.default.EditIconOutlined} variant='outlined' color='greyed' onClick={() => { setEditMode( true ); window.location.hash = "#Edit" }} >
                                    Edit
                                </Button>
                            </Tooltip>}
                            {attachments.length > 0 &&
                                <Button variant='outlined' color='greyed' startIcon={isDownloading ? Icons.default.DownloadingIcon : Icons.default.DownloadIconOutlined} disabled={isDownloading} onClick={downloadStudyMaterial}>
                                    Download
                                </Button>}
                            {+UserStore.getUser.user_id === +data.creator_user_id && UserStore.getUser.user_role !== "STUDENT" && <Tooltip disableInteractive title="Delete the complete material" placement="top">
                                <Button startIcon={Icons.default.DeleteIconOutlined} variant='outlined' color='error' onClick={() => setMaterialDeleteDialogState( true )} >
                                    Delete
                                </Button>
                            </Tooltip>}
                            {/* {UserStore.getUser.user_role !== "STUDENT" && <Button onClick={event => setActionsAnchorEl( event.currentTarget )} variant='outlined' color='secondary' sx={{ flexGrow: 1 }} endIcon={Icons.default.KeyboardArrowDownIcon}>
                                Actions
                            </Button>}
                            <Popper anchorEl={actionsAnchorEl} placement='bottom-end' open={Boolean( actionsAnchorEl )}>
                                <ClickAwayListener onClickAway={() => setActionsAnchorEl( null )}>
                                    <Paper sx={{ borderRadius: layout.borderRadius, border: border[1], marginTop: "5px", display: "flex", flexDirection: "column" }}>
                                        {attachments.length > 0 &&
                                            <MenuItem dense sx={{ gap: "10px", ":hover": { bgcolor: palette.action.hover } }} disabled={isDownloading} onClick={downloadStudyMaterial}>
                                                {isDownloading ? Icons.default.DownloadingIcon : Icons.default.DownloadIconOutlined}
                                                Download
                                            </MenuItem>}
                                        {+data.creator_user_id === +UserStore.getUser['user_id'] && <Tooltip disableInteractive title="Edit material details" placement="top">
                                            <MenuItem dense sx={{ gap: "10px", ":hover": { bgcolor: palette.action.hover } }} onClick={() => { setEditMode( true ); window.location.hash = "#Edit" }} >
                                                {Icons.default.EditIconOutlined}
                                                Edit
                                            </MenuItem>
                                        </Tooltip>}
                                        {+UserStore.getUser.user_id === +data.creator_user_id && <Tooltip disableInteractive title="Delete the complete material" placement="top">
                                            <MenuItem dense sx={{ gap: "10px", ":hover": { bgcolor: palette.action.hover } }} onClick={() => setMaterialDeleteDialogState( true )} >
                                                {Icons.default.DeleteIconOutlined}
                                                Delete
                                            </MenuItem>
                                        </Tooltip>}
                                    </Paper>
                                </ClickAwayListener>
                            </Popper> */}
                            {/* {attachments.length > 0 && UserStore.getUser.user_role === "STUDENT" &&
                                <Button variant='contained' color='customThemeColor' disableElevation startIcon={isDownloading ? Icons.default.DownloadingIcon : Icons.default.DownloadIconOutlined} disabled={isDownloading} onClick={downloadStudyMaterial}>
                                    Download
                                </Button>} */}
                            <ButtonGroup size='small' variant="contained" disableElevation sx={{ background: palette.greyedOut, border: `1px solid ${palette.borderColor}`, borderRadius: "20px", padding: "2px" }}>
                                <Tooltip title="List view" placement="top">
                                    <IconButton size='small' onClick={() => { localStorage.setItem( "studyMaterialView", "list" ); setViewType( "list" ) }} sx={{ color: viewType !== "grid" ? "primary.main" : "#666" }}>
                                        <List />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Grid view" placement="top">
                                    <IconButton size='small' onClick={() => { localStorage.setItem( "studyMaterialView", "grid" ); setViewType( "grid" ) }} sx={{ color: viewType === "grid" ? "primary.main" : "#666" }}>
                                        <GridViewIcon />
                                    </IconButton>
                                </Tooltip>
                            </ButtonGroup>
                        </Box>
                    </Box>
                    <Box flexGrow={1} display="flex" flexDirection="column" marginTop="10px" borderRadius="5px" >
                        {viewType === "grid" ?
                            <GridView setAddMode={setAddMode} renameAttachment={renameAttachment} removefilter={removefilter} setShowDetails={setShowDetails} setAttachmentsSelectedForDetails={setAttachmentsSelectedForDetails} attachments={filteredAttachments} allAttachments={attachments} material={data} deleteAttachment={deleteAttachment} /> :
                            <ListView setAddMode={setAddMode} renameAttachment={renameAttachment} removefilter={removefilter} material={data} setShowDetails={setShowDetails} setAttachmentsSelectedForDetails={setAttachmentsSelectedForDetails} attachments={filteredAttachments} allAttachments={attachments} deleteAttachment={deleteAttachment} />}
                    </Box>
                </Box>}
            {data && !data.study_material_id && <BlockMessage blockTitle="Material Not Found" type="error" message="Sorry, The study material you are looking for does not exists!" actions={[{ label: "Back to Materials", action: navigateToMaterials }]} />}
            {!isLoading && data && editMode && <Box>
                <MaterialEdit material={data} update={update} isUpdating={isUpdating} currentTags={data.study_material_tags.split( "," )} setEditMode={setEditMode} />
            </Box>}
            {/* {!isLoading && data && !editMode && manageAccessMode && <ManageAccess data={data} setManageAccessMode={setManageAccessMode} />} */}
            {isLoading && <Box sx={{ height: "100%" }}>
                <DataLoadingSpinner waitingMessage="Loading study material..." />
            </Box>}
        </Box>
    )
} )

export default Material
